<template>
  <i-container class="_align-self:stretch _padding:0" am-invites fluid>
    <i-card color="teal" size="sm" am-table-pane>
      <div class="_display:flex _justify-content:end">
        <i-button
          size="sm"
          color="info"
          @click="$router.push({
            name: 'AdminCreateInvite'
          })"
        >
          Create invite
          <i-icon name="ink-plus" class="_margin-left:1/2" />
        </i-button>
      </div>
    </i-card>
    <div class="_display:flex" am-table-cell>
      <div am-th-cell>Name</div>
      <div am-th-cell>Created at</div>
      <div am-th-cell>Role</div>
      <div am-th-cell>Actions</div>
    </div>
    <div am-table>
      <div v-for="(invite) in invites" :key="invite.id" class="_display:flex" >
          <div am-cell>{{invite.name}}</div>
          <div am-cell>{{dateConvert(invite.created_at)}}</div>
          <div am-cell>{{invite.role}}</div>
          <div am-cell>
            <i-button
              color="primary"
              @click="copyUrl(invite.code)"
              style="width: 100px;"
              class="_margin-right:1/2 _margin-bottom:1/4"
            >
              Copy link
            </i-button>
            <i-button
              @click="deleteInvite(invite)"
              style="width: 100px;"
              class="_margin-bottom:1/4"
            >
              Delete
            </i-button>
          </div>
      </div>
    </div>
    <div v-if="confirmDelete">
      <i-modal v-model="confirmDelete">
        <template #header>
          Delete invitation for {{ isDeleteData.name }}?
        </template>
        <div am-deleted-buttons>
          <i-button @click="notRemoved">
            No
          </i-button>
          <i-button @click="removed">
            Yes
          </i-button>
        </div>
      </i-modal>
    </div>
  </i-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    invites: null,
    confirmDelete: false,
    isDeleteData: null
  }),
  mounted () {
    this.getInvites()
  },
  computed: {
    ...mapState(['api'])
  },
  methods: {
    ...mapMutations('notifications', ['addNotification']),
    async getInvites () {
      this.invites = await this.$store.dispatch('getInvites')
    },
    dateConvert (publicationDate) {
      const date = new Date(publicationDate)
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }
      return date.toLocaleString('en', options)
    },
    copyUrl (code) {
      const url = `${this.api.siteUrl}/sign-up/${code}`
      navigator.clipboard.writeText(url)
      this.addNotification({
        notification: {
          type: 'success',
          message: 'Link copied to clipboard'
        }
      })
    },
    deleteInvite (invite) {
      this.isDeleteData = {
        id: invite.id,
        name: invite.name
      }
      this.confirmDelete = true
    },
    notRemoved () {
      this.confirmDelete = false
      this.isDeleteData = {}
    },
    async removed () {
      const isDelete = await this.$store.dispatch('deleteInvite', this.isDeleteData.id)
      this.confirmDelete = false
      this.isDeleteData = {}
      if (isDelete) {
        this.getInvites()
      }
    }
  }
}
</script>

<style lang="scss">
[am-invites] {
  ----font-size: 0.85rem;
  ----line-height: 1.2;
  ----spacing: 0.25rem;
  ----padding: #{var(----spacing)};

  font-size: var(----font-size);
  [am-table-cell], [am-table] {
    width: 100%;
    [am-cell], [am-th-cell] {
      width: calc(100% / 4);
    }
  }
  [am-table] {
    overflow: auto;
    height: calc(100vh - 100px);
    border-bottom: 1px solid var(--border-color);
    grid-template-rows: var(--rows);
    div:last-child {
      [am-cell] {
        border-bottom: 1px solid var(--border-color);
      }
    }
  }
  [am-deleted-buttons] {
    display: flex;
    justify-content: space-between;
    button {
      width: calc(50% - 5px);
    }
  }
}
</style>
